import {
    NOTIFICATION_ADMIN_LIST_FAIL,
    NOTIFICATION_ADMIN_LIST_REQUEST,
    NOTIFICATION_ADMIN_LIST_SUCCESS,
    NOTIFICATION_CREATE_FAIL,
    NOTIFICATION_CREATE_REQUEST,
    NOTIFICATION_CREATE_SUCCESS,
    NOTIFICATION_DELETE_FAIL,
    NOTIFICATION_DELETE_REQUEST,
    NOTIFICATION_DELETE_SUCCESS,
    NOTIFICATION_LIST_FAIL,
    NOTIFICATION_LIST_REQUEST,
    NOTIFICATION_LIST_SUCCESS,
    NOTIFICATION_MARK_ALL_READ_SUCCESS,
    NOTIFICATION_MARK_READ_SUCCESS,
    NOTIFICATION_UNREAD_COUNT_FAIL,
    NOTIFICATION_UNREAD_COUNT_REQUEST,
    NOTIFICATION_UNREAD_COUNT_SUCCESS
} from '../constants/notificationConstant'
import notificationService from '../services/notificationsServices'

const getError = error => error.response && error.response.data
    ? error.response.data.error
    : error.message

export const createNotification = (data) => async (dispatch) => {
    dispatch({ type: NOTIFICATION_CREATE_REQUEST })
    try {
        const response = await notificationService.create(data)
        dispatch({ type: NOTIFICATION_CREATE_SUCCESS, payload: response.data.message })
        dispatch(listAdminNotifications())
        dispatch(getUnreadNotificationsCount())
    } catch (error) {
        dispatch({ type: NOTIFICATION_CREATE_FAIL, payload: getError(error) })
    }
}

export const listNotifications = (search) => async (dispatch) => {
    dispatch({ type: NOTIFICATION_LIST_REQUEST })
    try {
        const { data } = await notificationService.list(search)
        dispatch({ type: NOTIFICATION_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: NOTIFICATION_LIST_FAIL, payload: getError(error) })
    }
}

export const listAdminNotifications = (search) => async (dispatch) => {
    dispatch({ type: NOTIFICATION_ADMIN_LIST_REQUEST })
    try {
        const { data } = await notificationService.adminList(search)
        dispatch({ type: NOTIFICATION_ADMIN_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: NOTIFICATION_ADMIN_LIST_FAIL, payload: getError(error) })
    }
}

export const getUnreadNotificationsCount = () => async (dispatch) => {
    dispatch({ type: NOTIFICATION_UNREAD_COUNT_REQUEST })
    try {
        const { data } = await notificationService.unreadCount()
        dispatch({ type: NOTIFICATION_UNREAD_COUNT_SUCCESS, payload: data.unreadCount })
    } catch (error) {
        dispatch({ type: NOTIFICATION_UNREAD_COUNT_FAIL, payload: getError(error) })
    }
}

export const markNotificationRead = (id) => async (dispatch) => {
    try {
        const { data } = await notificationService.markRead(id)
        dispatch({ type: NOTIFICATION_MARK_READ_SUCCESS, payload: data.notification })
        dispatch(getUnreadNotificationsCount())
    } catch (error) {
        dispatch({ type: NOTIFICATION_UNREAD_COUNT_FAIL, payload: getError(error) })
    }
}

export const markNotificationsRead = () => async (dispatch) => {
    try {
        await notificationService.markAllRead()
        dispatch({ type: NOTIFICATION_MARK_ALL_READ_SUCCESS })
    } catch (error) {
        dispatch({ type: NOTIFICATION_UNREAD_COUNT_FAIL, payload: getError(error) })
    }
}

export const deleteNotification = (id) => async (dispatch) => {
    dispatch({ type: NOTIFICATION_DELETE_REQUEST })
    try {
        const { data } = await notificationService.remove(id)
        dispatch({ type: NOTIFICATION_DELETE_SUCCESS, payload: data.message })
        dispatch(listAdminNotifications())
        dispatch(getUnreadNotificationsCount())
    } catch (error) {
        dispatch({ type: NOTIFICATION_DELETE_FAIL, payload: getError(error) })
    }
}
